import { AddressDTO } from './AddressDTO'

export class GiftedVoucherRedemptionDTO {
    constructor(
        public id: string,
        public giftedVoucherId: string,
        public amount: number,
        public venueId: string,
        public venueDisplayName: string,
        public dateCreated: string,
        public dateUnredeemed: string | null
    ) { }
}

export class GiftedVoucherDTO {
    constructor(
        public id: string,
        public venueId: string,
        public lineItemId: string,
        public shortCode: string | null,
        public amount: number,
        public currencyCode: string,
        public redeemed: boolean,
        public expiryDate: string | null,
        public recipientName: string | null,
        public postalDeliveryAddress: AddressDTO | null,
        public dateCreated: string,
        public dateUpdated: string,
        public redemptions: GiftedVoucherRedemptionDTO[] = []
    ) { }
}
